import { CancelConfirmModal } from '../../components/common';
import { OFFERING_LABEL } from './offeringsConfig';

export default function OfferingsCancelModal({ pledge, reason, onReasonChange, onConfirm, onClose, cancelling, isDerasarAdmin = false }) {
  return (
    <CancelConfirmModal
      entity={OFFERING_LABEL}
      item={pledge}
      itemDisplay={pledge?.donationCategoryId?.name}
      amount={pledge?.offeredAmount}
      title={isDerasarAdmin ? 'Cancel Offering' : 'Request Offering Delete'}
      confirmLabel={isDerasarAdmin ? 'Confirm Cancel' : 'Send Request'}
      extraNote={isDerasarAdmin ? undefined : 'This will be sent to the admin for approval before the offering is deleted.'}
      reason={reason}
      onReasonChange={onReasonChange}
      onConfirm={onConfirm}
      onClose={onClose}
      cancelling={cancelling}
    />
  );
}
